export default {
  title: {
    en: `
    Nice! You've successfully skipped your <span class="brandColor">next&nbsp;{count, plural, one {month} other {#&nbsp;months}}</span>.
    We won't bill you for the skipped months
    `,
  },
  text: {
    en: 'Your feedback matters! Could you tell us why you wanted to pause your subscription? ',
  },
  submitButton: {
    en: 'Submit',
  },
}
